import UserService from '@/services/UserService.js';

const users = {
  namespaced: true,

  state: {
    users: [],
    totalPages: 0,
    loadingUsers: false,
    usersChanged: 0,
  },

  actions: {
    async getUsers({ commit, state }, { pageSize, page, searchQuery }) {
      state.loadingUsers = true;
      try {
        const token = localStorage.getItem('token');
        const response = await UserService.getUsers(token, pageSize, page, searchQuery);
        state.users = response.data.users;
        state.totalPages = response.data.total_pages;
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrio un error al cargar los usuarios
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
      }
      state.loadingUsers = false;
    },
    async getUserDetail({ commit }, userId) {
      try {
        const token = localStorage.getItem('token');
        const response = await UserService.getUserDetail(token, userId);
        return response.data;
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrio un error al cargar el usuario
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return null;
      }
    },
    async createUser({ state, commit }, userData) {
      try {
        const token = localStorage.getItem('token');
        await UserService.createUser(token, userData);
        commit('ui/SHOW_ALERT', {
          alertMessage: 'Se creó el usuario correctamente',
          alertType: 'success'
        }, {root: true});
        state.usersChanged += 1;
        return { created: true };
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrio un error al crear el usuario
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return { created: false };
      }
    },
    async updateUser({ state, commit }, userData) {
      try {
        const token = localStorage.getItem('token');
        await UserService.updateUser(token, userData);
        commit('ui/SHOW_ALERT', {
          alertMessage: 'Se actualizó el usuario correctamente',
          alertType: 'success'
        }, {root: true});
        state.usersChanged += 1;
        return { updated: true };
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrio un error al actualizar el usuario
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return { updated: false };
      }
    },
    async deleteUser({ commit }, userId) {
      try {
        const token = localStorage.getItem('token');
        await UserService.deleteUser(token, userId);
        commit('ui/SHOW_ALERT', {
          alertMessage: 'Se eliminó el usuario correctamente',
          alertType: 'success'
        }, {root: true});
        return { deleted: true };
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrio un error al eliminar el usuario
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return { deleted: false };
      }
    },
  },
};

export default users;
